import React from "react";
import MainConfigurator from "./screens/MainConfigurator";

const App: React.FC = () => {

  return (
    <div className="">

      <MainConfigurator />
    </div>
  );
};

export default App;
